import { createSlice } from '@reduxjs/toolkit';

export const NavigationSlice = createSlice({
  name: 'navigation',
  initialState: {
    childrenByParent: {},
    loadedParents: {},
  },
  reducers: {
    setChildren: (state, action) => {
      const { parentId, childIds = [] } = action.payload || {};
      if (!parentId) {
        return;
      }
      const uniqueIds = Array.from(new Set(childIds.filter(Boolean)));
      state.childrenByParent[parentId] = uniqueIds;
      state.loadedParents[parentId] = true;
    },
    upsertChild: (state, action) => {
      const { parentId, childId } = action.payload || {};
      if (!parentId || !childId) {
        return;
      }
      const list = state.childrenByParent[parentId] || [];
      if (!list.includes(childId)) {
        state.childrenByParent[parentId] = [...list, childId];
      }
    },
    removeChild: (state, action) => {
      const { parentId, childId } = action.payload || {};
      if (!parentId || !childId) {
        return;
      }
      const list = state.childrenByParent[parentId];
      if (!Array.isArray(list)) {
        return;
      }
      state.childrenByParent[parentId] = list.filter(id => id !== childId);
    },
  },
});

export const { setChildren, upsertChild, removeChild } =
  NavigationSlice.actions;

export default NavigationSlice.reducer;
